import React, { Component } from 'react'
import { t } from '@billes/translator-client'

const styles = {
  label: (focus, value, isFile) => {
    return {
      position: 'absolute',
      lineHeight: '22px',
      top: '25px',
      zIndex: 1,
      cursor: 'text',
      pointerEvents: 'auto',
      WebkitUserSelect: 'none',
      color: focus && !value ? '#337ab7' : 'rgba(0, 0, 0, 0.298039)',
      transform:
        value || (focus && !isFile)
          ? 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0px)'
          : 'scale(1) translate3d(0px, 0px, 0px)',
      transformOrigin: 'left top 0px',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      userSelect: 'none',
      WebkituserSelect: 'none'
    }
  }
}

class FieldLabel extends Component {
  render() {
    const { nameKey, name, hasFocus, hasValue, isRequired, isFile } = this.props
    let label = name || t(nameKey)
    return (
      <span style={styles.label(hasFocus, hasValue, isFile)}>
        {label + (isRequired ? ' *' : '')}
      </span>
    )
  }
}

export default FieldLabel



// WEBPACK FOOTER //
// ./src/components/inputs/fieldLabel.js